import gql from "graphql-tag";

export const DEAL_CONFIGURATION_QUERY = gql`
  query dealConfiguration {
    dealConfiguration {
      types {
        id
        title
        code
      }
      stages {
        id
        title
        order
        closeType
        code
      }
      callTypes {
        id
        name
      }
    }
  }
`;

export const DEAL_LIST_QUERY = gql`
  query deals(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $createdAt_Gte: DateTime
    $createdAt_Lte: DateTime
    $leadGenerator_Id: ID
    $dealOwner_User_Id_In: [String]
    $dealOwner_User_Id_Isnull: Boolean
    $stageId: ID
    $stageId_In: [ID]
    $dealTypeId_In: [ID]
    $probability: String
    $probability_In: [String]
    $search: String
    $orderBy: String
  ) {
    deals(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      createdAt_Gte: $createdAt_Gte
      createdAt_Lte: $createdAt_Lte
      leadGenerator_Id: $leadGenerator_Id
      dealOwner_User_Id_In: $dealOwner_User_Id_In
      dealOwner_User_Id_Isnull: $dealOwner_User_Id_Isnull
      stageId: $stageId
      stageId_In: $stageId_In
      dealTypeId_In: $dealTypeId_In
      probability: $probability
      probability_In: $probability_In
      search: $search
      orderBy: $orderBy
    ) {
      totalCount
      edgeCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      edges {
        node {
          id
          stage {
            id
            code
            title
            order
          }
          createdAt
          updatedAt
          dealType {
            id
            title
          }
          contact {
            id
            firstName
            lastName
            email
            phone
            user {
              id
              firstName
              lastName
              email
              userProfile {
                id
                phone
              }
            }
          }
          dealOwner {
            id
            user {
              id
              firstName
              lastName
              email
            }
          }
          leadGenerator {
            id
            firstName
            lastName
            email
          }
          dealcallSet {
            id
            callTime
            callOutcome
            callType {
              id
              name
            }
            caller {
              id
              firstName
              lastName
            }
            note
          }
          subscription {
            id
            startDate
            endDate
            product {
              id
              type
            }
          }
          probability
          closedAt
          lastCallTime
        }
      }
    }
  }
`;

export const DEAL_OWNERS_QUERY = gql`
  query dealOwners {
    dealOwners {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

export const DEAL_QUERY = gql`
  query deal($id: ID!) {
    deal(id: $id) {
      id
      createdAt
      closedAt
      note
      attributionCampaign
      attributionMedium
      attributionSource
      lastCallTime
      contact {
        id
        firstName
        lastName
        email
        phone
        user {
          id
          firstName
          lastName
          email
          userProfile {
            id
            phone
          }
        }
      }
      leadGenerator {
        id
        firstName
        lastName
      }
      subscription {
        id
        product {
          id
          type
        }
      }
      stage {
        id
        title
        code
      }
      probability
      dealOwner {
        id
        user {
          id
          firstName
          lastName
        }
      }
      dealcallSet {
        id
        createdAt
        caller {
          id
          firstName
          lastName
        }
        callOutcome
        callTime
        note
        callType {
          id
          name
        }
      }
      changeLog {
        changedAt
        changedBy
        changeType
        changes
      }
    }
  }
`;

export const DEAL_CONTACT_SEARCH_QUERY = gql`
  query dealContactSearch($search: String!) {
    dealContactSearch(search: $search) {
      contacts {
        id
        firstName
        lastName
        email
        phone
        user {
          id
          firstName
          lastName
        }
      }
      users {
        id
        firstName
        lastName
        email
        userProfile {
          id
          phone
        }
      }
    }
  }
`;

export const DEAL_USER_SEARCH_QUERY = gql`
  query dealUserSearch($email: String!) {
    dealUserSearch(email: $email) {
      id
      firstName
      lastName
      email
    }
  }
`;

export const DEAL_TYPES_QUERY = gql`
  query dealTypes {
    dealTypes {
      id
      title
    }
  }
`;

export const DEAL_STATS_QUERY = gql`
  query dealStats($userLimit: Int) {
    dealStats(userLimit: $userLimit) {
      unassignedDeals
      callsLogged {
        id
        firstName
        lastName
        total
      }
      newDeals
      dealsWon {
        id
        firstName
        lastName
        total
      }
      dealsClosed {
        id
        firstName
        lastName
        total
      }
    }
  }
`;

export const DEAL_REPORT_NEW_LEADS_BY_DEAL_TYPE = gql`
  query dealReportNewLeadsByDealType($startDate: Date!, $endDate: Date!, $dealOwners: [ID], $dealTypes: [ID]) {
    dealReportNewLeadsByDealType(
      startDate: $startDate
      endDate: $endDate
      dealOwners: $dealOwners
      dealTypes: $dealTypes
    )
  }
`;

export const DEAL_REPORT_OVERALL_LEADS = gql`
  query dealReportOverallLeads($startDate: Date!, $endDate: Date!, $dealOwners: [ID]) {
    dealReportOverallLeads(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_CALLS_BY_DEAL_TYPE = gql`
  query dealReportCallsByDealType($startDate: Date!, $endDate: Date!, $dealOwners: [ID], $dealTypes: [ID]) {
    dealReportCallsByDealType(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners, dealTypes: $dealTypes)
  }
`;

////////////
export const DEAL_REPORT_CALL_BREAKDOWN = gql`
  query dealReportCallBreakdown($startDate: Date!, $endDate: Date!, $dealOwners: [ID]) {
    dealReportCallBreakdown(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_NOT_PITCHED = gql`
  query dealReportNotPitched($startDate: Date!, $endDate: Date!, $dealOwners: [ID]) {
    dealReportNotPitched(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_CLOSE_BREAKDOWN = gql`
  query dealReportCloseBreakdown($startDate: Date!, $endDate: Date!, $dealOwners: [ID]) {
    dealReportCloseBreakdown(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_OWNER_NUMBER_OF_CALLS = gql`
  query dealReportOwnerNumberOfCalls($startDate: Date!, $endDate: Date!, $dealOwners: [ID]!) {
    dealReportOwnerNumberOfCalls(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_OWNER_NUMBER_OF_PITCHES = gql`
  query dealReportOwnerNumberOfPitches($startDate: Date!, $endDate: Date!, $dealOwners: [ID]!) {
    dealReportOwnerNumberOfPitches(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;

export const DEAL_REPORT_OWNER_NUMBER_OF_WON_DEALS = gql`
  query dealReportOwnerNumberOfWonDeals($startDate: Date!, $endDate: Date!, $dealOwners: [ID]!) {
    dealReportOwnerNumberOfWonDeals(startDate: $startDate, endDate: $endDate, dealOwners: $dealOwners)
  }
`;
